import { render, staticRenderFns } from "./InboxContentContactBox.vue?vue&type=template&id=eeff88c2&scoped=true&"
import script from "./InboxContentContactBox.vue?vue&type=script&lang=js&"
export * from "./InboxContentContactBox.vue?vue&type=script&lang=js&"
import style0 from "./InboxContentContactBox.vue?vue&type=style&index=0&id=eeff88c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeff88c2",
  null
  
)

export default component.exports